import { Dispatch } from 'react';
import { Editor } from '@tiptap/react';
import {
  Thread,
  CommentsProvider as ICommentsProvider,
} from '../../../entities/tiptap-editor/extensions/Comments/types';
import { commentsModel } from '../model';

export type ProviderOptions = {
  dispatch: Dispatch<any>;
  updateCommentThread: (
    id: string,
    data: Partial<Pick<Thread, 'markedAsDeleted'>>
  ) => void;
};

export class CommentsProvider implements ICommentsProvider {
  private dispatch: Dispatch<any>;
  public threads: Thread[] = [];
  public updateCommentThread: (id: string, data: Partial<Thread>) => void;
  public isSynced = true;
  public synced = false;

  constructor(options: ProviderOptions) {
    this.dispatch = options.dispatch;
    this.updateCommentThread = options.updateCommentThread;
  }

  createPendingThread({ editor }: { editor: Editor }) {
    this.dispatch(
      commentsModel.actions.startCommentingFlow({
        onCreate: (threadId) => {
          editor.commands.setThread(threadId, {});
        },
        onError: (error) => {
          // Nothing to do here
          console.log(error);
        },
        onCancel: () => {
          editor.chain().setTextSelection(0).run();
        },
      })
    );
  }

  markThreadAsDeleted({
    id,
    markedAsDeleted,
  }: {
    editor: Editor;
    id: string;
    markedAsDeleted: boolean;
  }) {
    this.updateCommentThread(id, { markedAsDeleted });
    this.dispatch(
      commentsModel.actions.markThreadAsDeleted({
        threadId: id,
        markedAsDeleted,
      })
    );
  }

  getThreads() {
    return this.threads;
  }
  setThreads(threads: Thread[]) {
    this.threads = threads;
  }

  deleteThread(threadId: string) {
    // TODO: implement
  }
}
